import React, { Image } from 'react';

export default class Home extends React.Component {
   
    render() {
        const style = {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        }

        return (
            < div >
                <div style={style}>
                    <div>
                        <div className={'container '}>
                            <h1 style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <img style={{ width: '50%', height: null }} src={require('../Resources/Images/playstore-icon.png')} />
                            </h1>
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <img
                                    style={{ width: '55%', height: null }}
                                    onClick={()=> window.open('https://play.google.com/apps/testing/com.aipcsoft.gochallengeme', "_blank")}                                    
                                    src={require('../Resources/Images/google-play-badge.png')} />

                                {/* <img
                                    style={{ width: '45%' }}
                                    src={require('../Resources/Images/app-store-badge.svg')} /> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        );
    }
}


// WEBPACK FOOTER //
// ./src/Component/Home.js